import { AnswerEntityId, Contact, ReferenceContactId } from "@sp-crm/core";
import { ContactCard, ContactCardActions } from "components/contacts/card";
import React from "react";
import {
    AdvancedSearchEntityType,
    useGetReferenceContactQuery,
} from "../../generated/graphql";
import { ErrorMessage } from "../ui/error-message";
import { Spinner } from "../ui/spinner";

interface ReferenceContactCardProps {
    referenceId: ReferenceContactId;
    parentEntityType: AdvancedSearchEntityType;
    parentEntityId: AnswerEntityId;
    actions: React.ReactNode;
}

const FallbackWithActions: React.FC<{
    actions: React.ReactNode;
    children: React.ReactNode;
}> = props => (
    <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0">{props.children}</div>
        <ContactCardActions>{props.actions}</ContactCardActions>
    </div>
);

export const ReferenceContactCard: React.FC<ReferenceContactCardProps> = props => {
    const query = useGetReferenceContactQuery({ id: props.referenceId });
    if (query.isError) {
        return (
            <FallbackWithActions actions={props.actions}>
                <ErrorMessage component="ReferenceContactCard">
                    <pre className="whitespace-pre-wrap break-all">
                        {JSON.stringify(query.error, null, 2)}
                    </pre>
                </ErrorMessage>
            </FallbackWithActions>
        );
    }
    if (query.isLoading) {
        return <Spinner />;
    }
    const contact = query.data?.getReferenceContact.contactEntity;
    if (!contact) {
        return (
            <FallbackWithActions actions={props.actions}>
                Sorry, no contact information found
            </FallbackWithActions>
        );
    }

    return (
        <ContactCard
            contact={Contact.load(contact)}
            parentId={props.parentEntityId}
            parentEntityType={props.parentEntityType}
            actions={props.actions}
        />
    );
};
